import { createListenerMiddleware } from '@reduxjs/toolkit';
import { APP_FEATURE, createListenerEffect, FEATURE_TYPE, selectSplitInit } from '@socialive/common';
import { initSplitSdk } from '@splitsoftware/splitio-redux';
import selectSplitAttributes from '~/selectors/selectSplitAttributes';
import { getTreatments } from '~/thunks';

export const effect = createListenerEffect(
  'features/initAndLoadSplitsForApp<Listener>',
  async (action, { dispatch, getState, unsubscribe, trigger }) => {
    unsubscribe();

    const { authorizationKey, app, featureTypes } = selectSplitInit(getState());

    // Dispatch `initSplitSdk`
    await dispatch(
      initSplitSdk({
        config: {
          core: {
            authorizationKey,
            key: app,
          },
        },
      })
    );

    // Dispatch `getTreatments` to fetch all of the "app" features for "guest" from Split
    /** @deprecated All new features should be accountFeatures */
    if (featureTypes[FEATURE_TYPE.APP]) {
      await dispatch(
        getTreatments({
          splitNames: Object.values(APP_FEATURE),
          key: app,
          attributes: selectSplitAttributes(getState()),
          trigger,
        })
      );
    }
  }
);

export const predicate = (action, state) => !!selectSplitInit(state);

const { startListening, middleware } = createListenerMiddleware();

startListening({
  predicate,
  effect,
});

export default middleware;
